import { InjectionToken } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';

// Define a template for date formats
export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/dd/yyyy',
  },
  display: {
    dateInput: 'MM/dd/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'MM/dd/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

export const MAT_CUSTOM_DATE_FORMATS = new InjectionToken('CustomDateFormats');